'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../css/ControlBase.css');

var _Icon = require('./Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _utilsLib = require('utils-lib');

var _modelsLib = require('models-lib');

var _Vas = require('../Vas');

var _Vas2 = _interopRequireDefault(_Vas);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
Pflichtproperties:
AppURL={Vas.ApplicationUrl} 
me={this} Id={"name"} ref={"name"} name="name"
IsRequired={true/false} Editable={true/false}  
Label={ Vas.Resources.Labels["Name"]} 
TitleMessageNotValidCharacter={Vas.Resources.Labels["Note"]} 
MessageNotValidCharacter={Vas.Resources.Labels["NotValidCharacter"]} 

optional:
Modus={"Name"} Tooltip={Vas.Resources.Tooltips["Name"]} OnChange={()=>{ this.setState({ Name:  $("#name").val() })}}
Autocomplete={false/true}=>"off"/"on"
*/
var EmailField = function (_Component) {
  _inherits(EmailField, _Component);

  function EmailField(props) {
    _classCallCheck(this, EmailField);

    var _this = _possibleConstructorReturn(this, (EmailField.__proto__ || Object.getPrototypeOf(EmailField)).call(this, props));

    _this.state = {};
    _this.state.isrequired = _this.props.IsRequired;
    _this.state.required = true;
    _this.state.editable = _this.props.Editable;
    _this.state.Label = _this.props.Label;
    _this.state.Value = _this.props.Value;
    _this.state.Placeholder = _this.props.Placeholder;
    _this.state.OnKeyDown = _this.props.OnKeyDown;
    _this.state.OnChange = _this.props.OnChange;
    _this.state.autocomplete = _this.props.Autocomplete;
    _this.state.EmailValid = false;
    _this.state.EmailExist = false;
    _this.state.Start = true;

    _this.EmailModel = new _modelsLib.EmailModel([_this]);
    _this.Request = new _modelsLib.RequestAjaxClass(function (error) {
      _this.props.ErrorHandlingPage(error);
    }, null);
    return _this;
  }

  _createClass(EmailField, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.Request.setAuth(false);
      this.Request.setApiKey(this.props.ApiKey);
      this.Request.setApiUrl(this.props.ApiUrl);

      this.EmailModel.SetRequest(this.Request);

      if (this.props.Modus) {
        this.setState({ Modus: this.props.Modus });
      }
    }
  }, {
    key: 'Update',
    value: function Update(observer) {
      var _this2 = this;

      var me = this;
      this.setState({}, function () {
        if (observer === "CheckMail") {
          if (me.EmailModel.ValidSyntax === true && me.EmailModel.AccountExists === false) {
            me.setState({ Email: (0, _jquery2.default)("#" + me.props.Id).val(), EmailValid: true, EmailExist: false, Start: false }, function () {
              if (_this2.props.Reference) {
                _this2.props.Reference.Update("EmailChecked");
              }
            });
          } else {
            if (me.EmailModel.ValidSyntax === false) {
              me.setState({ Email: (0, _jquery2.default)("#" + me.props.Id).val(), EmailValid: false, EmailExist: false, Start: false }, function () {
                if (_this2.props.Reference) {
                  _this2.props.Reference.Update("EmailChecked");
                }
              });
            } else {
              me.setState({ Email: (0, _jquery2.default)("#" + me.props.Id).val(), EmailValid: false, EmailExist: true, Start: false }, function () {
                if (_this2.props.Reference) {
                  _this2.props.Reference.Update("EmailChecked");
                }
              });
            }
          }
        }
      });
    }
  }, {
    key: 'checkEmail',
    value: function checkEmail(id) //Überprüft die Email-Adresse auf Validität
    {
      if ((0, _jquery2.default)("#" + id).val().length > 0) {
        var res = _utilsLib.CheckEmail.Check((0, _jquery2.default)("#" + id).val());

        var me = this;

        if (res === true) {
          this.Request.setErrorHandler(function () {
            me.setState({ Email: (0, _jquery2.default)("#" + id).val(), EmailValid: false, EmailExist: false });
          });

          this.EmailModel.CheckMail((0, _jquery2.default)("#" + id).val());
        } else {
          me.setState({ Email: (0, _jquery2.default)("#" + id).val(), EmailValid: false, EmailExist: false });
        }
      } else {
        this.setState({ Start: true });
      }
    }
  }, {
    key: 'getValid',
    value: function getValid() {
      return this.state.EmailValid;
    }
  }, {
    key: 'getExist',
    value: function getExist() {
      return this.state.EmailExist;
    }
  }, {
    key: 'tab',
    value: function tab(event, me) {
      if (event) {
        if (event.keyCode === 13 || event.keyCode === 9) {
          (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
          me.checkFields();

          var filled = true;

          if (me.state.isrequired) {
            if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
              filled = false;
            } else {
              filled = true;
            }
          }

          var docs = document.querySelectorAll('button,input,div.ss-selected-option,select');
          var maxId = docs.length;
          var aktive = document.activeElement.id;
          var i = void 0;
          for (i = 0; i <= maxId - 1; i++) {
            if (docs[i].id === aktive) {
              if (i === maxId - 1) {
                docs[i].blur();
                break;
              } else {
                if (event.shiftKey && event.keyCode === 9) {
                  for (var j = i - 1; j >= 0; j--) {
                    if (!docs[j].readOnly) {
                      docs[j].focus();
                      break;
                    } else if (docs[j].className === "ss-selected-option") {
                      var _event = new Event("click");
                      docs[j].dispatchEvent(_event);
                      break;
                    }
                  }
                } else {
                  for (var _j = i + 1; _j <= maxId - 1; _j++) {
                    if (!docs[_j].readOnly) {
                      docs[_j].focus();
                      break;
                    } else if (docs[_j].className === "ss-selected-option") {
                      var _event2 = new Event("click");
                      docs[_j].dispatchEvent(_event2);
                      break;
                    }
                  }
                }
              }
            }
          }
          me.setState({ required: filled });
        } else if (event.keyCode === undefined) {
          (0, _jquery2.default)("#" + me.props.Id).val(_utilsLib.XssFilter.getText((0, _jquery2.default)("#" + me.props.Id).val()));
          me.checkFields();
          var _filled = true;
          if (me.state.isrequired) {
            if ((0, _jquery2.default)("#" + me.props.Id).val().length === 0) {
              _filled = false;
            } else {
              _filled = true;
            }
          }
          me.setState({ required: _filled });
        }
      }
    }
  }, {
    key: 'checkFields',
    value: function checkFields() {
      if (this.props.me) {
        var docs = document.querySelectorAll('select,input');
        var docRefs = this.props.me.refs;
        _utilsLib.CheckValues.checkAllFields(docs, docRefs, this.props.Id);
      }
    }
  }, {
    key: 'focus',
    value: function focus(id) {
      (0, _jquery2.default)("#" + id).select();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var iconRedTrue = '';
      var iconRedFalse = '';
      var iconGreen = '';
      var iconStart = _react2.default.createElement(_Icon2.default, {
        Align: "left",
        Color: "red",
        Name: "",
        Size: 24
      });
      if (this.state.Start === false) {
        if (this.state.EmailValid === true) {
          iconGreen = _react2.default.createElement(_Icon2.default, {
            Align: "left",
            Color: "green",
            Name: "Done",
            Size: 24,
            For: this.props.Id
          });
          iconStart = '';
        } else {
          if (this.state.EmailExist === true) {
            iconRedTrue = _react2.default.createElement(_Icon2.default, {
              Align: "left",
              Color: "red",
              Name: "Warning",
              Size: 24,
              Tooltip: _Vas2.default.getText('Labels', "EmailExist"),
              For: this.props.Id
            });
            iconStart = '';
          } else {
            iconRedFalse = _react2.default.createElement(_Icon2.default, {
              Align: "left",
              Color: "red",
              Name: "Warning",
              Size: 24,
              Tooltip: _Vas2.default.getText('Labels', "EmailNotValid"),
              For: this.props.Id
            });
            iconStart = '';
          }
        }
      }

      var Tooltip = _react2.default.createElement(
        'span',
        { id: this.props.Id + "Tooltip" },
        this.props.Tooltip ? this.props.Tooltip : _Vas2.default.getText('Tooltips', 'Email')
      );

      var FieldNotFilled = "";
      if (this.props.FieldNotFilledHint && this.props.FieldNotFilledHint !== "") {
        FieldNotFilled = _react2.default.createElement(
          'div',
          { id: this.props.Id + "FieldNotFilled", className: "fieldNotFilled" },
          this.props.FieldNotFilledHint
        );
      }

      var controlClassName = "textfield";
      var Style = null;
      if (this.props.Width) {
        Style = { width: this.props.Width, float: this.props.Float };
      }

      var readOnly = false;
      var isTextFieldFilled = true;
      if (this.state.editable) {

        if (this.state.isrequired) {
          if (this.state.required) {
            controlClassName = "textfield";
            readOnly = false;
          } else {
            controlClassName = "textfieldNotFilled";
            readOnly = false;
            isTextFieldFilled = false;
          }
        } else {
          controlClassName = "textfield";
          readOnly = false;
        }
      } else {
        controlClassName = "textfieldDisabled";
        readOnly = true;
      }
      var type = "text";

      if (this.props.Type) {
        type = this.props.Type;
      }

      var autocom = "on";
      if (this.state.autocomplete) {
        if (this.state.autocomplete === false) {
          autocom = "off";
        }
      }

      var isTextFieldFilledStyle = { visibility: 'hidden' };

      if (!isTextFieldFilled) {
        isTextFieldFilledStyle = { visibility: 'visible' };
      }

      return _react2.default.createElement(
        'div',
        { className: "ef" },
        _react2.default.createElement(
          'label',
          {
            className: 'textfieldLabel',
            style: Style,
            'for': this.props.Id },
          this.state.Label,
          ' ',
          Tooltip
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'table',
            null,
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  null,
                  _react2.default.createElement('input', {
                    autoComplete: autocom,
                    className: controlClassName,
                    id: this.props.Id,
                    onBlur: function onBlur(e) {
                      if (_this3.props.OnBlur) {
                        _this3.props.OnBlur();
                      }_this3.tab(e, _this3);
                    },
                    onChange: function onChange() {
                      _this3.checkEmail(_this3.props.Id);if (_this3.state.OnChange) {
                        _this3.state.OnChange();
                      }
                    },
                    onFocus: function onFocus() {
                      _this3.focus(_this3.props.Id);
                    },
                    onInput: this.props.onInput,
                    onKeyDown: function onKeyDown(e) {
                      if (e.keyCode === 9) {
                        e.preventDefault();
                      }if (_this3.state.OnKeyDown) {
                        _this3.state.OnKeyDown();
                      }_this3.tab(e, _this3);
                    },
                    placeholder: this.state.Placeholder,
                    readOnly: readOnly,
                    style: Style,
                    tabIndex: this.props.Tabindex,
                    type: type,
                    value: this.state.Value
                  })
                ),
                _react2.default.createElement(
                  'td',
                  null,
                  iconRedTrue,
                  iconRedFalse,
                  iconGreen,
                  iconStart
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { id: this.props.Id + "FieldNotFilled", style: isTextFieldFilledStyle },
          FieldNotFilled
        )
      );
    }
  }]);

  return EmailField;
}(_react.Component);

exports.default = EmailField;